<template>
  <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">Supplier Code</th>
          <th class="text-left">Stocks</th>
          <th class="text-left">Sold</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in products"
          :key="item.id"
          style="cursor: pointer"
          @click="goToProduct(item.id)"
        >
          <td class="text-left">{{ item.name }}</td>
          <td class="text-left">{{ item.supplier_code }}</td>
          <td class="text-left">{{ parseFloat(item.stock).toLocaleString() }}</td>
          <td class="text-left">{{ parseFloat(item.sold).toLocaleString() }}</td>
        </tr>
        <tr v-if="products.length == 0">
          <td colspan="4" style="height:300px;text-align: center">
            No records found
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: ['products'],
  data: function() {
    return {};
  },
  methods: {
    goToProduct(id) {
      this.$router.push(`/product/${id}`);
    }
  }
};
</script>
